import { useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { alpha, Box, Fade, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Logo } from '../../components/Logo';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';
import { getUserStore, type FrontendId } from '../../store/UserStore';
import AppVersion from '@ai/uimain/src/components/AppVersion';

export const Auth = ({ logoImg, frontendId }: { logoImg: string; frontendId: FrontendId }) => {
  const { t } = useTranslation();
  const isBelowMd = useMediaQuery(useTheme().breakpoints.down('md'));

  useEffect(() => {
    getUserStore(frontendId).resetUser();
  }, []);

  return (
    <Fade in timeout={300}>
      <Stack
        direction={isBelowMd ? 'column' : 'row'}
        minHeight={'100vh'}
        minWidth={'100%'}
        bgcolor={(theme) => theme.palette.background.paper}
      >
        <Stack
          alignItems={'center'}
          justifyContent={isBelowMd ? 'flex-start' : 'center'}
          width={isBelowMd ? '100%' : '50%'}
          height={isBelowMd ? undefined : '100%'}
          // borderRight={(theme) => `1px solid ${theme.palette.primary.alpha12}`}
          sx={{
            backgroundColor: (theme) => alpha(theme.palette.neutral[100], 0.5),
            // backgroundImage: "url('img/login-bg.png')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '30% 100%',
          }}
          p={4}
        >
          {isBelowMd && (
            <Stack direction="row" alignSelf={'flex-end'}>
              <LanguageSwitcher frontendId={frontendId} />
            </Stack>
          )}

          <Stack p={5} spacing={2} maxWidth="40em">
            <Link to="https://nlabteam.com/" target="_blank">
              <Logo height={64} logoImg={logoImg} />
            </Link>

            {/* <Typography fontSize={"4em"} color={"primary.main"}>
              {t("title")}
            </Typography> */}

            <Box />

            <Typography color="primary.main" whiteSpace="pre-wrap">
              {t('login.welcomeText')}
            </Typography>
          </Stack>
        </Stack>

        <Stack alignItems={'center'} width={isBelowMd ? '100%' : '50%'} p={4} flexGrow={1} gap={2}>
          {!isBelowMd && (
            <Stack direction="row" alignSelf={'flex-end'}>
              <LanguageSwitcher frontendId={frontendId} />
            </Stack>
          )}

          <Stack flexGrow={1} justifyContent={'center'}>
            <Outlet />
          </Stack>

          <AppVersion />
        </Stack>
      </Stack>
    </Fade>
  );
};
